<template>
    <announcement-common isNew></announcement-common>
</template>
<script>
import announcementCommon from './announcementCommon.vue';

export default {
    name: 'announcementAdd',
    components: {
        announcementCommon,
    },
};
</script>
